function UserNewIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 22.75C11.3 22.75 10.59 22.48 10.06 21.95L8.34998 20.26C7.92998 19.84 7.35001 19.61 6.76001 19.61H6C3.93 19.61 2.25 17.94 2.25 15.89V4.97C2.25 2.92 3.93 1.25 6 1.25H18C20.07 1.25 21.75 2.92 21.75 4.97V15.88C21.75 17.93 20.07 19.6 18 19.6H17.24C16.65 19.6 16.07 19.84 15.65 20.25L13.94 21.94C13.41 22.48 12.7 22.75 12 22.75ZM6 2.75C4.76 2.75 3.75 3.75 3.75 4.97V15.88C3.75 17.11 4.76 18.1 6 18.1H6.76001C7.75001 18.1 8.70997 18.5 9.40997 19.19L11.12 20.88C11.61 21.36 12.4 21.36 12.89 20.88L14.6 19.19C15.3 18.5 16.26 18.1 17.25 18.1H18C19.24 18.1 20.25 17.1 20.25 15.88V4.97C20.25 3.74 19.24 2.75 18 2.75H6Z"
        fill="white"
      />
      <path
        d="M12.0698 9.70078C12.0498 9.70078 12.0198 9.70078 11.9998 9.70078C11.9698 9.70078 11.9298 9.70078 11.8998 9.70078C10.4398 9.65078 9.2998 8.47078 9.2998 7.00078C9.2998 5.51078 10.5098 4.30078 11.9998 4.30078C13.4898 4.30078 14.6998 5.51078 14.6998 7.00078C14.6898 8.47078 13.5498 9.65078 12.0898 9.70078C12.0898 9.70078 12.0798 9.70078 12.0698 9.70078ZM11.9998 5.80078C11.3398 5.80078 10.7998 6.34078 10.7998 7.00078C10.7998 7.65078 11.3098 8.18078 11.9498 8.20078C11.9498 8.19078 12.0098 8.19078 12.0798 8.20078C12.7098 8.16078 13.1998 7.64078 13.1998 7.00078C13.1998 6.34078 12.6598 5.80078 11.9998 5.80078Z"
        fill="white"
      />
      <path
        d="M12 16.6981C10.86 16.6981 9.72002 16.3981 8.83002 15.8081C7.99002 15.2481 7.5 14.4381 7.5 13.5781C7.5 12.7181 7.98002 11.8981 8.83002 11.3381C10.61 10.1581 13.39 10.1581 15.16 11.3381C16 11.8981 16.49 12.7181 16.49 13.5681C16.49 14.4281 16.01 15.2381 15.16 15.8081C14.28 16.4081 13.14 16.6981 12 16.6981ZM9.65997 12.5881C9.22997 12.8781 9 13.2281 9 13.5781C9 13.9281 9.23997 14.2781 9.65997 14.5681C10.93 15.4181 13.06 15.4181 14.33 14.5681C14.76 14.2781 15 13.9281 14.99 13.5781C14.99 13.2281 14.75 12.8781 14.33 12.5881C13.07 11.7381 10.93 11.7381 9.65997 12.5881Z"
        fill="white"
      />
    </svg>
  );
}

export default UserNewIcon;
